import { vr, currentPage, initNewSection } from '../common/layout';
import {
  hitPageView,
  checkAndFilterCoralCommentsAmountToShow,
} from '../common/utils/fn';
import { banners } from '@banners';
import { getLoadMoreContent } from '../common/utils/load-more-btn-new.-loader';
// import device from 'current-device';
// import 'jquery-scrolltie';
// import { getPlayVideoEmbed } from '../common/utils/playVideoEmbed-loader';
import { getCoralCommentsCountUpdate } from '../common/utils/coral-requests-loader';
// import '../common/jquery-snap-scroll';

async function initializeFindVehicleWidget() {
  const findVehicleEuWidget = document.querySelector('.m1-find-vehicle-eu');
  const findVehicleUsWidget = document.querySelector('.m1-find-vehicle-us');
  if (findVehicleEuWidget) {
    const { getM1FindVehicleEu, getM1FindVehicleByType } =
      await import('../common/shop/m1-find-vehicle-widget-loader');
    getM1FindVehicleEu().then((api) => api.m1FindVehicleEu());
    getM1FindVehicleByType().then((api) => api.m1FindVehicleByType());
  } else if (findVehicleUsWidget) {
    const { getM1FindVehicleByType, getM1FindVehicleUs } =
      await import('../common/shop/m1-find-vehicle-widget-loader');
    getM1FindVehicleUs().then((api) => api.m1FindVehicleUs());
    getM1FindVehicleByType().then((api) => api.m1FindVehicleByType());
  }
}

currentPage.pageInit = ($page, pageData, pageId) => {
  const dataEdtn = document.body.dataset.edtn;
  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });

  // $('.msnt-items-slider').snapScrollControl();

  let currentURL = window.location.href;
  var url = new URL(currentURL);
  var searchLoginM1 = url.searchParams.get('is_comment_login');
  if (searchLoginM1) {
    if (searchLoginM1 == '1') {
      window.close();
    }
  }

  // let collectedVideoEmbeds = document.querySelectorAll('.videoplayer');
  // if (collectedVideoEmbeds.length > 0) {
  //   getPlayVideoEmbed().then((api) => {
  //     api.playVideoEmbed(collectedVideoEmbeds);
  //   });
  // }

  getCoralCommentsCountUpdate().then((api) => {
    api.coralCommentsCountUpdate();
  });

  initializeFindVehicleWidget();

  checkAndFilterCoralCommentsAmountToShow();
};

currentPage.pageLoadMore = ($html, $btnBox) => {
  initNewSection($html);
  const dataEdtn = document.body.dataset.edtn;

  let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
  loadMoreButton?.addEventListener('click', (event) => {
    event.preventDefault();
    getLoadMoreContent().then((api) => {
      api.loadMoreButtonNew(loadMoreButton);
    });
  });

  // let collectedVideoEmbeds = document.querySelectorAll('.videoplayer');
  // if (collectedVideoEmbeds.length > 0) {
  //   getPlayVideoEmbed().then((api) => {
  //     api.playVideoEmbed(collectedVideoEmbeds);
  //   });
  // }

  initializeFindVehicleWidget();

  getCoralCommentsCountUpdate().then((api) => {
    api.coralCommentsCountUpdate();
  });
  banners($html);
  hitPageView(document.location.pathname);
  checkAndFilterCoralCommentsAmountToShow();
};
